"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var list = document.querySelector("ul");
function getSalary(element) {
    return Number(element.dataset.salary.replace("$", "").replace(",", ""));
}
function sortList(employeeList) {
    var employees = _to_consumable_array(employeeList.children);
    var sortedList = employees.sort(function(a, b) {
        return getSalary(b) - getSalary(a);
    });
    sortedList.forEach(function(item) {
        return employeeList.append(item);
    });
}
function getEmployees(employeeList) {
    return _to_consumable_array(employeeList.children).map(function(employee) {
        return {
            name: employee.textContent.trim(),
            position: employee.dataset.position,
            salary: getSalary(employee),
            age: Number(employee.dataset.age)
        };
    });
}
sortList(list);
var employeeData = getEmployees(list);
// eslint-disable-next-line no-console
console.log(employeeData);

//# sourceMappingURL=index.0e5b8d1b.js.map
